import { ADD_DFOS_LIST, ADD_DFOS_LIST_ERROR, ADD_DFOS_LIST_SUCCESS, DELETE_DFOS_LIST, DELETE_DFOS_LIST_ERROR, DELETE_DFOS_LIST_SUCCESS, DFOS_LIST, DFOS_LIST_DETAILS, DFOS_LIST_DETAILS_ERROR, DFOS_LIST_DETAILS_SUCCESS, DFOS_LIST_ERROR, DFOS_LIST_SUCCESS, EDIT_DFOS_LIST, EDIT_DFOS_LIST_ERROR, EDIT_DFOS_LIST_SUCCESS, USERS_LIST, USERS_LIST_ERROR, USERS_LIST_SUCCESS } from './constants';



export default function dfosreducer(state, action) {
    
	let dfos = [];
	

	switch (action.type) {

	case DFOS_LIST:
		return { ...state, loading : true, error : false};

	case DFOS_LIST_SUCCESS:
		if(action?.payload){
			action.payload.map((item) => {
                
				dfos.push({
					id : item.id,
					name : item.name ? item.name : '',
					userId: item.userId ? item.userId : 'null',
					pidsinfoId: item?.pidsinfoId ?  item?.pidsinfoId : null,
					pidsname: item?.pidsinfo.name ? item?.pidsinfo.name  : 'No Data',
					pipelineId : item?.pipelineId ?  item?.pipelineId : null,
					username:item?.users ?  `${item?.users.firstName +' ' + item?.users.lastName}` : 'No Data'
 
				});
			});
		}
		return {...state, dfos : dfos,  loading : false, error : false};

	case DFOS_LIST_ERROR:
		return { ...state, dfos : [], loading : false, error : true};

	case ADD_DFOS_LIST:
		return { ...state, loading: true };
	case ADD_DFOS_LIST_SUCCESS:
		return { ...state, loading: false, error: false };

	case ADD_DFOS_LIST_ERROR:
		return {...state, loading : false, error : true};

	case EDIT_DFOS_LIST:
		return { ...state, loading: true, error: false };

	case EDIT_DFOS_LIST_SUCCESS:
		return { ...state,  loading: false, error : false };

	case EDIT_DFOS_LIST_ERROR:
		return {...state, loading : false, error : true};

	case DFOS_LIST_DETAILS:
		return { ...state, loading: true };

	case DFOS_LIST_DETAILS_SUCCESS:
		return { ...state, loading: false, details:action.payload, error: false };

	case DFOS_LIST_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case DELETE_DFOS_LIST:
		return { ...state, loading: false };

	case DELETE_DFOS_LIST_SUCCESS:
		return { ...state, loading: false, error: false };

	case DELETE_DFOS_LIST_ERROR:
		return { ...state, loading: false, error: true };

	
	case USERS_LIST:
		return { ...state, pending: true };
	case USERS_LIST_SUCCESS:
		return { ...state, users_data: action.payload, pending: false };
	case USERS_LIST_ERROR:
		return { ...state, error: true, pending: false };

	default: 
		throw Error('Unknown action: ' + action.type);
      
	}
}